module.exports = __webpack_public_path__ + "img/aliens-eyes.bb2f14db.png";